import { HttpClient } from '../httpClient';
import { DataResponse } from '../responses/baseResponse';
import TimesheetApprovalProofingResponse from '../responses/timesheetApprovalProofingResponse';
import TimesheetProofingDetail from '../models/timesheetProofingDetail';
import TimesheetStatusesResponse from '../responses/timesheetStatusesResponse';
import TimesheetEntryFlagRequest from '../requests/timesheetEntryFlagRequest';
import TimesheetFlagRequest from '../requests/timesheetFlagRequest';
import TimesheetSubmitRequest from '../requests/timesheetSubmitRequest';

const httpClient = new HttpClient();

export const getTimesheetProofingApprovalSummary = async (
  divisionId: number,
  year: number,
  month: number
) => {
  return httpClient.get<DataResponse<TimesheetApprovalProofingResponse>>({
    url: `/v1/Proofing/Summary?divisionId=${divisionId}&year=${year}&month=${month}`,
    requiresToken: true,
  });
};

export const getTimesheetProofingDetail = async (
  timesheetId: number,
  districtId: number = 0
) => {
  return httpClient.get<DataResponse<TimesheetProofingDetail>>({
    url: `/v1/Proofing/Detail?districtId=${districtId}&timesheetId=${timesheetId}`,
    requiresToken: true,
  });
};

export const getTimesheetWeek = async (timesheetWeekId: number) => {
  return httpClient.get<TimesheetStatusesResponse>({
    url: `/v1/Proofing/status?timesheetWeekId=${timesheetWeekId}`,
    requiresToken: true,
  });
};

export const updateFlagStatus = async (
  timesheetEntryFlagRequest: TimesheetEntryFlagRequest
) => {
  return httpClient.put<TimesheetStatusesResponse>({
    url: `/v1/Proofing/updateEntryFlagStatus`,
    payload: timesheetEntryFlagRequest,
    requiresToken: true,
  });
};

export const updateTimesheetFlagStatus = async (
  timesheetFlagRequest: TimesheetFlagRequest
) => {
  return httpClient.put<TimesheetStatusesResponse>({
    url: `/v1/Proofing/updateTimesheetFlagStatus`,
    payload: timesheetFlagRequest,
    requiresToken: true,
  });
};

export const updateTimesheet = async (
  timesheetWeekId: number,
  request: TimesheetSubmitRequest
) => {
  return httpClient.put<TimesheetStatusesResponse>({
    url: `/v1/Proofing/UpdateTimesheetStatus/${timesheetWeekId}`,
    payload: request,
    requiresToken: true,
  });
};

export const hasDecreasedHours = async (timesheetId: number) => {
  return httpClient.get<DataResponse<boolean>>({
    url: `/v1/Proofing/HasDecreasedHours?timesheetId=${timesheetId}`,
    requiresToken: true,
  });
};
